angular.module('iw.frontyard.string')
    .directive('iwTrim', function (StringHelper) {
        return {
            restrict: 'A',
            link: function ($scope, element, attributes) {
                var trimmed = StringHelper.trim(element.text());
                element.text(trimmed);
            }
        };
    });
